// @flow

export const provideBlogUrl = (url: string): string => `/blog/${url}`

export default provideBlogUrl
